import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ClientLandingPage from "./ClientLandingPage";
import ClientPortal from "./ClientPortal";
import axios from "axios";
import ClientHeader from "./ClientHeader";
import "../../styling/App.css";
import LeftPanelClientPortal from "../panels/LeftPanelClientPortal";
import ClientAccountInfo from "./ClientAccountInfo";
import { useProfile } from "../../ProfileContext";

const ClientContainer = () => { 
  const { setProfileImage } = useProfile();

  const [client, setClient] = useState({});
  const [brandingColours, setBrandingColours] = useState({
    primaryColor: "#2A1980",
    secondaryColor: "#ffffff",
  });
  const [selectedTab, setSelectedTab] = useState("landing");
  const [events, setEvents] = useState([]);
  const [brandLogo, setBrandLogo] = useState(null);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [effectiveBusinessId, setEffectiveBusinessId] = useState(null);
  const [initialBusinessEventTab, setInitialBusinessEventTab] = useState(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/client-user`, {
          withCredentials: true,
        });
        
        // Fix for Line 49: Use 'data' from response instead of 'clientData'
        const data = response.data.data;
        setClient(data);
        setProfileImage(data.profilePicUrl);

        const urlId = searchParams.get("businessId");
        const sessionId = sessionStorage.getItem('loginBusinessId');
        const profileId = data?.businessId;

        const bId = urlId || sessionId || profileId;
        setEffectiveBusinessId(bId);
      } catch (error) {
        console.log("Error fetching client data: ", error);
      }
    };

    fetchClientData();
  }, [setProfileImage]); // Removed searchParams dependency to prevent infinite loops

  useEffect(() => {
    const fetchBusinessData = async () => {
      // Logic fix: Only run if we actually have the ID now
      if (!effectiveBusinessId) return;

      try {
        const brandingResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/client/get-branding`,
          { businessId: effectiveBusinessId }, // Fix for Line 67: Use effectiveBusinessId
          { withCredentials: true }
        );
        const { primaryColor, secondaryColor, brandLogo } = brandingResponse.data;
        setBrandingColours({ primaryColor, secondaryColor });
        setBrandLogo(brandLogo);

        const eventsResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/client/events/${effectiveBusinessId}`, // Fix for Line 76: Use effectiveBusinessId
          { withCredentials: true }
        );
        setEvents(eventsResponse.data.data);
      } catch (error) {
        console.log("Error fetching business-specific data: ", error);
      }
    };

    fetchBusinessData();
  }, [effectiveBusinessId]);

  const handleTabSwitch = (tab) => {
    setSelectedTab(tab); 
  };

  const handleBacktoAccount = () => {
    setSelectedTab("landing");
  };

  const handleAccountDropdownClick = () => {
    setShowAccountInfo(!showAccountInfo);
  };

  return (
    <div className="client-container">
      <div style={{ backgroundColor: "#f2f2f2" }}>
          <ClientHeader
            style={{ backgroundColor: "#ffffff" }}
            brandLogo={brandLogo}
            clientData={client}
            onAccountDropdownClick={handleAccountDropdownClick}
            setInitialBusinessEventTab={setInitialBusinessEventTab}
            handleTabSwitch={handleTabSwitch}
            setShowAccountInfo={setShowAccountInfo}
            businessId={effectiveBusinessId} // Fix for Line 116: Use effectiveBusinessId
          />
        {!showAccountInfo ? (
          <div className="main-content" style={{ marginTop: "65px"}}>
            <div className="clientProfileDetails">
              <LeftPanelClientPortal
                handleBackToAccount={handleBacktoAccount}
                clientData={client}
                brandingColours={brandingColours}
                selectedTab={selectedTab}
              />
            </div>
            <div className="clientLandingTabs">
              {selectedTab === "landing" ? (
                <ClientLandingPage
                  brandingColours={brandingColours}
                  handleTabSwitch={handleTabSwitch}
                  events={events}
                  clientId={client._id}
                />
              ) : (
                <ClientPortal 
                  brandingColours={brandingColours} 
                  clientData={client} 
                  initialTabIndex={initialBusinessEventTab} 
                  businessId={effectiveBusinessId} // Fix for Line 139: Use effectiveBusinessId
                />
              )}
            </div>
          </div>
        ) : (
          <ClientAccountInfo clientData={client} />
        )}
      </div>
    </div>
  );
};

export default ClientContainer;